import { RatingSize, RatingsSummaryWidget } from '@migros/msrc-community';
import { ArticleHeading, ArticleText, Box, Display, Stack, ThemeContext, media, styled } from '@migros/msrc-ui-kit';
import React, { useContext } from 'react';
import { ListStyleType, TileLayout } from '../../../helpers';
import { whiteTransparent } from '../utils';
export const ArticleBody = ({
  badge,
  colorVariantsIndicator,
  frozenIndicator,
  description,
  energyEfficiency,
  heading,
  hideDescription,
  hideEnergyEfficiency,
  hideRating,
  hideBadge,
  language,
  layout = TileLayout.default,
  mode = ListStyleType.default,
  name,
  noPriceText,
  originalPrice,
  price,
  ratings
}) => {
  const themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    size: ['xsmall']
  }, /*#__PURE__*/React.createElement(Stack, {
    size: ['xsmall'],
    orientation: "horizontal",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(PriceWrapper, {
    size: ['tiny']
  }, !hideBadge && badge, price ? /*#__PURE__*/React.createElement(Box, {
    display: ['flex'],
    alignItems: ['baseline'],
    flexWrap: ['wrap'],
    background: [whiteTransparent]
  }, /*#__PURE__*/React.createElement(Display, {
    as: "span",
    sizeFont: ['large'],
    display: ['inline-block'],
    lineHeight: ['tight'],
    marginRight: ['xsmall'],
    color: ['black', 85],
    "data-testid": "msrc-articles--article-price"
  }, price), originalPrice && /*#__PURE__*/React.createElement(StyledOriginalPrice, {
    as: 'span',
    sizeFont: ['tiny', 'xtiny'],
    display: ['inline-block'],
    lineHeight: ['tight'],
    "data-testid": "msrc-articles--article-original-price",
    mode: mode
  }, originalPrice)) : noPriceText && /*#__PURE__*/React.createElement(ArticleText, {
    as: "span",
    sizeFont: ['tiny', 'xsmall'],
    display: ['inline-block'],
    lineHeight: ['tight'],
    "data-testid": "msrc-articles--article-no-price-text"
  }, noPriceText)), colorVariantsIndicator && /*#__PURE__*/React.createElement(ColorVariantsIndicatorContainer, {
    marginBottom: ['tiny']
  }, colorVariantsIndicator), frozenIndicator && /*#__PURE__*/React.createElement(FrozenIndicatorContainer, null, frozenIndicator)), /*#__PURE__*/React.createElement(Stack, {
    size:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [null, 'tiny'],
    background: [whiteTransparent]
  }, /*#__PURE__*/React.createElement(ArticleHeading, {
    as: heading,
    lineHeight: ['tight'],
    sizeFont: mode === ListStyleType.condensed ? ['tiny', 'xsmall'] : ['tiny', 'xtiny'],
    clampLines: layout === TileLayout.default ? mode === ListStyleType.condensed ? 2 : 3 : undefined,
    truncate: layout === TileLayout.mini ? true : undefined,
    "data-testid": "msrc-articles--article-name"
  }, name), !hideDescription && description && /*#__PURE__*/React.createElement(ArticleText, {
    lineHeight: ['normal'],
    sizeFont: ['tiny', 'xtiny'],
    color: ['gray', 80],
    truncate: true,
    dangerouslySetInnerHTML: {
      __html: description
    },
    "data-testid": "msrc-articles--article-description"
  })), !hideRating && ratings && /*#__PURE__*/React.createElement(RatingWrapper, {
    "data-testid": "msrc-articles--article-rating"
  }, /*#__PURE__*/React.createElement(RatingsSummaryWidget, {
    count: ratings.count,
    rating: ratings.average,
    language: language,
    size: RatingSize.tiny,
    theme: themeContext === null || themeContext === void 0 ? void 0 : themeContext.themeId
  }))), !hideEnergyEfficiency && energyEfficiency && energyEfficiency.arrow_alternative && energyEfficiency.arrow_alternative.original && /*#__PURE__*/React.createElement(EnergyEfficiencyImage, {
    src: energyEfficiency.arrow_alternative.original,
    "data-testid": "msrc-articles--article-energy-efficiency"
  }));
};
const EnergyEfficiencyImage = styled.img`
  height: 20px;
`;
const PriceWrapper = styled(Stack)`
  flex-grow: 1;
`;
const ColorVariantsIndicatorContainer = styled(Box)`
  flex-shrink: 0;
`;
const FrozenIndicatorContainer = styled(Box)`
  flex-shrink: 0;
`;
const StyledOriginalPrice = styled(ArticleText)`
  ${({
  mode
}) => mode === ListStyleType.condensed ? 'margin-top: -3px' : null}
  font-family: ${({
  theme: {
    fonts
  }
}) => fonts.families.articleText};
  color: ${({
  theme: {
    colors
  }
}) => colors.tints.black[85]};
  font-weight: ${({
  theme: {
    fonts
  }
}) => fonts.weights.regular};

  ${({
  mode
}) => media.tabletAndUp`
    ${mode === ListStyleType.condensed ? 'margin-top: 0' : null};
  `}
`;
const RatingWrapper = styled(Box)`
  svg.Star {
    color: ${({
  theme: {
    colors
  }
}) => colors.brand.text[100]};
  }

  svg.StarOutline {
    color: ${({
  theme: {
    colors
  }
}) => colors.tints.gray[45]};
  }

  svg.StarHalf > path:first-child {
    color: ${({
  theme: {
    colors
  }
}) => colors.brand.text[100]};
  }

  svg.StarHalf > path:last-child {
    fill: ${({
  theme: {
    colors
  }
}) => colors.tints.gray[45]} !important;
  }

  span > span {
    color: ${({
  theme: {
    colors
  }
}) => colors.tints.gray[45]};
  }
`;